import { c as _c } from "react/compiler-runtime";
import React, { useState, useMemo, useCallback } from 'react';
import { Helmet } from 'react-helmet-async';
import PropTypes from 'prop-types';
import { GET_FABRIC_DATA } from '@/graphql/queries';
import { INSPIRATION_PAGE_SEO_DESCRIPTION } from 'commons/constants';
import useSuspenseQuery from 'commons/useSuspenseQuery';
import useScreen from 'hooks/useScreen';
import InspirationPage from './inspiration-page';
const InspirationPhotoGridInner = t0 => {
  const $ = _c(7);
  const {
    fabricsData
  } = t0;
  const [mobileItemsPerRow, setMobileItemsPerRow] = useState(3);
  const {
    isMobile
  } = useScreen();
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => {
      setMobileItemsPerRow(_temp);
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const toggleMobileItemsPerRow = t1;
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      title: "Customer Photos | Joybird",
      description: INSPIRATION_PAGE_SEO_DESCRIPTION,
      ogTitle: "Customer Photos by Joybird.com",
      ogUrl: "https://joybird.com/customer-photos/",
      ogImage: "https://joybird2.imgix.net/meta/jb0916-FacebookPageThumbnails-CustomerGallery-v1.jpg?auto=compress,format"
    };
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const seoMeta = t2;
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <Helmet><title>{seoMeta.title}</title><meta name="description" content={seoMeta.description} /><meta property="og:type" content="website" /><meta property="og:title" content={seoMeta.ogTitle} /><meta property="og:description" content={seoMeta.description} /><meta property="og:url" content={seoMeta.ogUrl} /><meta property="og:image" content={seoMeta.ogImage} /></Helmet>;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== fabricsData || $[4] !== isMobile || $[5] !== mobileItemsPerRow) {
    t4 = <>{t3}<InspirationPage mobileItemsPerRow={mobileItemsPerRow} toggleMobileItemsPerRow={toggleMobileItemsPerRow} fabricsData={fabricsData} isMobile={isMobile} /></>;
    $[3] = fabricsData;
    $[4] = isMobile;
    $[5] = mobileItemsPerRow;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  return t4;
};
InspirationPhotoGridInner.propTypes = {
  fabricsData: PropTypes.array
};
const InspirationPhotoGrid = props => {
  const $ = _c(3);
  const {
    data
  } = useSuspenseQuery(GET_FABRIC_DATA);
  const fabricsData = data?.getFabrics ?? null;
  let t0;
  if ($[0] !== fabricsData || $[1] !== props) {
    t0 = <InspirationPhotoGridInner fabricsData={fabricsData} {...props} />;
    $[0] = fabricsData;
    $[1] = props;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  return t0;
};
export default InspirationPhotoGrid;
function _temp(prevState) {
  const options = [1, 2, 3];
  const indexOfPrev = options.indexOf(prevState);
  return indexOfPrev < options.length - 1 ? options[indexOfPrev + 1] : options[0];
}